export const useStyles = () => ({
  root: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    pointerEvents: 'none',
    '& > #gamecastVideoTag': {
      position: 'absolute !important',
      left: '0 !important',
      top: '0 !important',
      width: '100% !important',
      height: '100% !important',
      pointerEvents: 'auto',
      visibility: 'hidden',
      background: '#000000',
    },
  },
});
